<template>
  <section v-editable="blok" class="two-column" :style="gridStyle">
    <div class="two-column__item">
      <StoryblokComponent
        v-for="childBlok in blok.left_column"
        :key="childBlok._uid"
        :blok="childBlok"
      />
    </div>
    <div class="two-column__item">
      <StoryblokComponent
        v-for="childBlok in blok.right_column"
        :key="childBlok._uid"
        :blok="childBlok"
        :card-padding-data="cardPaddingData"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type {
  SbPluginResponsiveSpacingNumbers,
  SbSimpleTwoColumnsStoryblok,
} from '@/types'

interface Props {
  blok: SbSimpleTwoColumnsStoryblok
  cardPaddingData?: SbPluginResponsiveSpacingNumbers
}
const props = defineProps<Props>()

const gridStyle = computed(() => {
  return {
    '--column-gap': `${props.blok.column_gap || 0}px`,
    '--row-gap': `${props.blok.row_gap || 0}px`,
  }
})
</script>

<style lang="scss" scoped>
.two-column {
  --column-gap: 0;
  --row-gap: 0;

  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: var(--column-gap);
  row-gap: var(--row-gap);

  &__item {
    grid-column: span 2;

    @media (min-width: $breakpoint-lg) {
      grid-column: span 1;
    }
  }
}
</style>
